import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICoreMemberDTO } from '@app/core/model';
import { SharedMemberService } from '@app/shared/services/shared-member.service';
import { ShellService } from '@mynexus/mfe-core';

@Injectable({
  providedIn: 'root',
})
export class MemberHHService extends SharedMemberService {
  constructor(http: HttpClient, shellService: ShellService) {
    super(http, shellService, 'HH');
  }

  mapMemberDTO(memberDto: object): ICoreMemberDTO {
    return {
      memberId: memberDto['memberId'],
      benefitPlanID: memberDto['benefitPlanID'],
      benefitPlanName: memberDto['benefitPlanName'],
      firstName: memberDto['firstName'],
      isEligible: memberDto['isEligible'],
      lastName: memberDto['lastName'],
      lineOfBusiness: memberDto['lineOfBusiness'],
      streamData: {},
      subscriberNumber: memberDto['subscriberNumber'],
      gender: memberDto['gender'],
      dateOfBirth: memberDto['dateOfBirth'],
      lineOfBusinessId: memberDto['lineOfBusinessId'],
      eligibilityEffectiveBeginDate: memberDto['effectiveBeginDate'],
      eligibilityEffectiveEndDate: memberDto['effectiveEndDate']
    };
  }
}